module.exports = __webpack_public_path__ + "static/img/312.00072237.jpg";